module.exports = __webpack_public_path__ + "Flaticon.37ef8b6920621ed05641.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/font/Flaticon.ttf
// module id = ../../../../../src/assets/font/Flaticon.ttf
// module chunks = styles